<avi-card class="licensing-page-status-card">
    <avi-card_header>
        <div class="licensing-page-status-card__header">
            <cds-icon
                shape="certificate"
                size="24"
                status="success"
            ></cds-icon>
            <div class="licensing-page-status-card__header-text">{{ headerTitle | uppercase }}</div>
        </div>
    </avi-card_header>
    <avi-card_body>
        <div class="licensing-page-status-card__body">
            <div
                class="licensing-page-status-card__field"
                *ngIf="isEnterpriseWithCloudServicesTier"
            >
                <h6>{{ l10nKeys.clusterNameLabel | vtranslate }}</h6>
                <div>{{ clusterName ?? "-" }}</div>
            </div>
            <div
                class="licensing-page-status-card__field"
                *ngIf="isEnterpriseWithCloudServicesTier"
            >
                <h6>{{ l10nKeys.portalUrlLabel | vtranslate }}</h6>
                <div>{{ portalUrl ?? "-" }}</div>
            </div>
            <div
                class="licensing-page-status-card__field"
                *ngIf="!isEnterpriseWithCloudServicesTier"
            >
                <h6>{{ l10nKeys.onPremLicensingServiceUrlLabel | vtranslate }}</h6>
                <div>{{ onPremLicensingServiceUrl ?? "-" }}</div>
            </div>
            <div class="licensing-page-status-card__field">
                <h6>{{ l10nKeys.connectivityStatusLabel | vtranslate }}</h6>
                <div class="licensing-page-status-card__status">
                    <cds-icon
                        shape="circle"
                        size="12"
                        [status]="connectivityStatus"
                        [solid]="true"
                        *ngIf="!busy"
                    ></cds-icon>
                    <clr-spinner
                        [clrSmall]="true"
                        class="licensing-page-status-card__status-spinner"
                        *ngIf="busy"
                    ></clr-spinner>
                    <span>{{ connectivityStatusText ?? '-' }}</span>
                </div>
            </div>
            <div class="licensing-page-status-card__field">
                <h6>{{ l10nKeys.lastRefreshLabel | vtranslate }}</h6>
                <div>{{ (lastRefresh | aviDate) ?? '-' }}</div>
            </div>
        </div>
    </avi-card_body>
    <avi-card_footer *ngIf="showFooterSection">
        <ng-container *ngIf="deregisterLoading; else deregisterLoadingLoaded">
            <div class="licensing-page-status-card__status-spinner">
                <clr-spinner clrSmall></clr-spinner>
            </div>
        </ng-container>
        <ng-template #deregisterLoadingLoaded>
            <cds-button
                (click)="handleCloudLicensingRegistration()"
                (keydown.enter)="handleCloudLicensingRegistration()"
                status="primary"
                action="solid"
                size="sm"
                *ngIf="isUnregisteredAndConnected || canSubscribeCloud"
            >
                {{ l10nKeys.completeRegistrationLabel | vtranslate }}
            </cds-button>
             <cds-button
                (click)="handleCancelRegistration()"
                (keydown.enter)="handleCancelRegistration()"
                status="primary"
                action="flat"
                size="sm"
                *ngIf="isUnregisteredAndConnected"
            >
                {{ globalL10nKeys.cancelLabel | vtranslate }}
            </cds-button>
            <cds-button
                (click)="isOnPremLicensing ? disconnectFromOnPrem() : deregisterCloudLicensing()"
                (keydown.enter)="isOnPremLicensing ? disconnectFromOnPrem() : deregisterCloudLicensing()"
                size="sm"
                action="flat"
                status="danger"
                *ngIf="canDeregisterOnPrem || canDeregisterCloud"
            >
                {{ (isOnPremLicensing ? l10nKeys.disconnectOnPremLicensingLabel : l10nKeys.disconnectFromCloudServiceLabel) | vtranslate }}
            </cds-button>
        </ng-template>
    </avi-card_footer>
</avi-card>
